export const DEFAULT_DRUID_FILTERS_LIST = [
  'origin',
  'user_data_environment',
  'last_attributed_touch_data_tilde_creative_id',
  'last_attributed_touch_data_tilde_tune_publisher_id',
  'last_attributed_touch_data_dollar_marketing_title',
  'last_attributed_touch_data_tilde_content_id',
  'attributed',
  'user_data_platform',
  'last_attributed_touch_data_tilde_campaign',
  'last_attributed_touch_data_tilde_channel',
  'last_attributed_touch_data_tilde_organic_search_url',
  'last_attributed_touch_data_tilde_feature',
  'last_attributed_touch_data_tilde_stage',
  'last_attributed_touch_data_tilde_tags',
  'last_attributed_touch_data_tilde_advertising_partner_name',
  'last_attributed_touch_data_dollar_3p',
  'last_attributed_touch_data_tilde_ad_name',
  'last_attributed_touch_data_tilde_secondary_publisher',
  'last_attributed_touch_data_tilde_creative_name',
  'last_attributed_touch_data_tilde_ad_set_name',
  'last_attributed_touch_data_tilde_id',
  'last_attributed_touch_data_plus_web_format',
  'last_attributed_touch_type',
  'last_attributed_touch_data_tilde_keyword',
  'last_attributed_touch_data_tilde_keyword_id',
  'user_data_geo_country_code',
  'user_data_os',
  'user_data_os_version',
  'last_attributed_touch_data_tilde_customer_ad_name',
  'last_attributed_touch_data_tilde_customer_ad_set_name',
  'last_attributed_touch_data_tilde_customer_campaign',
  'last_attributed_touch_data_tilde_customer_keyword',
  'last_attributed_touch_data_tilde_customer_placement',
  'last_attributed_touch_data_tilde_customer_secondary_publisher',
  'last_attributed_touch_data_tilde_ad_id',
  'last_attributed_touch_data_tilde_ad_set_id',
  'last_attributed_touch_data_tilde_campaign_id',
  'last_attributed_touch_data_tilde_placement',
  'last_attributed_touch_data_tilde_sub_site_name',
  'last_attributed_touch_data_tilde_customer_sub_site_name',
  'last_attributed_touch_data_tilde_agency_id',
  'last_attributed_touch_data_tilde_agency',
  'user_data_geo_dma_code',
  'user_data_brand',
  'user_data_device_type',
  'user_data_model',
  'user_data_geo_country_en',
  'user_data_geo_region_en',
  'customer_event_alias',
  'first_event_for_user',
  'dismissal_source',
  'event_data_custom_param_1',
  'user_data_app_store',
];
